export default import.meta.ROLLDOWN_FILE_URL_rU3HiywN1hgln5fsonHW0Q